import { Outlet } from 'react-router'

export const AppLayout = () => {
  return (
    <>
      <Outlet />
    </>
  )
}
